import classNames from 'classnames';
import type { ReactNode } from 'react';
type Props = {
  label: string;
  icon?: string;
  className?: string;
  children: ReactNode;
};

export function DocumentLink({ label, icon = 'library_books', className, children }: Props) {
  return (
    <>
      <span className="divider bg-secondary bg-opacity-20 h-1px"></span>
      <li className={classNames(`list-group-item flex-x justify-content-between p-0 h-40px`, className)}>
        <div className="flex-x gap-2 px-2">
          <i className="icon icon-outlined text-secondary icon-sm">
            <span>{icon}</span>
          </i>
          <h6 className="fs-5 fw-medium">
            <span>{label}</span>
          </h6>
        </div>
        <div className="flex-x p-2">{children}</div>
      </li>
    </>
  );
}
